import type {BusinessPoolAccount} from '@/types';

import type {PoolAccountAction} from './types';
import {PoolAccountActionType} from './types';

const updatePoolAccountReducer = (
  state: BusinessPoolAccount,
  action: PoolAccountAction,
) => {
  switch (action.type) {
    case PoolAccountActionType.UPDATE_POOL_ACCOUNT:
      return {
        ...state,
        ...action.payload,
      };

    case PoolAccountActionType.UPDATE_POOL_ACCOUNT_FLAG:
      return {
        ...state,
        meta: {
          ...state.meta,
          flags: {
            ...state.meta?.flags,
            ...action.payload,
          },
        },
      };

    case PoolAccountActionType.UPDATE_POOL_ACCOUNT_EXTRA_PROPS:
      return {
        ...state,
        meta: {
          ...state.meta,
          extraProps: action.payload,
        },
      };

    case PoolAccountActionType.ADD_POOL_ACCOUNT_EXTRA_PROP: {
      const {key, value} = action.payload;
      const prevExtraProps = state.meta?.extraProps ?? {};
      return {
        ...state,
        meta: {
          ...state.meta,
          extraProps: {...prevExtraProps, [key]: value},
        },
      };
    }

    case PoolAccountActionType.REMOVE_POOL_ACCOUNT_EXTRA_PROP: {
      const removeKey = action.payload;
      const prevExtraProps = state.meta?.extraProps ?? {};
      const {[removeKey]: _, ...rest} = prevExtraProps;
      return {
        ...state,
        meta: {
          ...state.meta,
          extraProps: rest,
        },
      };
    }

    default:
      return state;
  }
};

export default updatePoolAccountReducer;
